// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3whSb","footer":"Form_footer__38MKm"};